export const FLAG_PREFIX = "REACT_APP_FFLAG_";

function parseBooleanFlag(flagValue: string): boolean {
  return /^true$/i.test(flagValue);
}

function parseNumericFlag(flagValue: string): number {
  return isNaN(+flagValue) ? 0 : +flagValue;
}

type Converter<T> = (flagValue: string) => T;

export class Flag<T> {
  name: string;
  _converter: Converter<T>;

  constructor(name: string, converter: Converter<T>) {
    this.name = name;
    this._converter = converter;
  }

  static Boolean(flagName: string): Flag<boolean> {
    return new Flag<boolean>(flagName, parseBooleanFlag);
  }

  static Numeric(flagName: string): Flag<number> {
    return new Flag<number>(flagName, parseNumericFlag);
  }

  static String(flagName: string): Flag<string> {
    return new Flag<string>(flagName, (flagValue) => flagValue);
  }

  getValue(): T | null {
    const rawValue = process.env[`${FLAG_PREFIX}${this.name}`];
    return rawValue ? this._converter(rawValue) : null;
  }
}
